import { SvgIcon } from '@mui/material';
import React from 'react';

export function WalletSVG (props) {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" stroke='currentColor' viewBox="0 0 24 24" fill="none">
                <path d="M17.5 8V5C17.5 4.73478 17.3946 4.48043 17.2071 4.29289C17.0196 4.10536 16.7652 4 16.5 4H6.5C5.96957 4 5.46086 4.21071 5.08579 4.58579C4.71071 4.96086 4.5 5.46957 4.5 6M4.5 6C4.5 6.53043 4.71071 7.03914 5.08579 7.41421C5.46086 7.78929 5.96957 8 6.5 8H18.5C18.7652 8 19.0196 8.10536 19.2071 8.29289C19.3946 8.48043 19.5 8.73478 19.5 9V12M4.5 6V18C4.5 18.5304 4.71071 19.0391 5.08579 19.4142C5.46086 19.7893 5.96957 20 6.5 20H18.5C18.7652 20 19.0196 19.8946 19.2071 19.7071C19.3946 19.5196 19.5 19.2652 19.5 19V16" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M20.5 12V16H16.5C15.9696 16 15.4609 15.7893 15.0858 15.4142C14.7107 15.0391 14.5 14.5304 14.5 14C14.5 13.4696 14.7107 12.9609 15.0858 12.5858C15.4609 12.2107 15.9696 12 16.5 12H20.5Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </SvgIcon>
    );
}
